<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Login</h2>
        <div class="form-section">
            <div class="form-group">
                <label>API Key</label>
                <input type="password" placeholder="Enter your API key" v-model="password" />
            </div>
            <button class="button button-full" @click="handleLogin">Login</button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { login } from '../services/optilogicService';
import { showMessage } from '../utils/messages';

// Define the events this component can emit
const emit = defineEmits(['logged-in']);

const username = ref('');
const password = ref('');


const handleLogin = () => {
    const apiKey = password.value;
    login(apiKey).then(result => {
        if (result.success) {
            console.log('Login Successful:', result.data);
            showMessage('Login successful!');
            emit('logged-in', { username: username.value, password: password.value }); // Emit event for parent component
        } else {
            console.error('Login Failed:', result.error);
            showMessage(result.error); // Display error in UI
        }
    });
};

</script>